import { useQuery } from '@apollo/react-hooks'
import { AchievementInfos, GetAchievementsResponse } from '@interfaces/Achievements'
import { GET_ACHIEVEMENTS } from '@queries/achievements'
import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'
import { useEffect } from 'react'
import { WatchQueryFetchPolicy } from 'apollo-client'

interface UseAchievementsOptions {
  fetchPolicy?: WatchQueryFetchPolicy
  skip?: boolean
  refetchOnVisibility?: boolean
}

const useAchievements = (options: UseAchievementsOptions = {}) => {
  const profile = useSelector(({ userProfile }: StoreProps) => userProfile.info)
  const {
    loading,
    data: GetAchievements,
    refetch,
  } = useQuery<GetAchievementsResponse>(GET_ACHIEVEMENTS, {
    variables: {
      studentProfileId: profile?.SFId,
    },
    fetchPolicy: options.fetchPolicy,
    skip: options.skip || !profile?.SFId,
  })

  useEffect(() => {
    if (!options.refetchOnVisibility || options.skip || !profile?.SFId) return

    const handleVisibilityChange = () => {
      if (document.hidden) return
      refetch().catch((error) => console.error('Achievements refresh error:', error))
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [options.refetchOnVisibility, options.skip, profile?.SFId, refetch])

  return { loading, Achievements: GetAchievements?.getAchievements?.data ?? ([] as AchievementInfos[]) }
}

export default useAchievements
